<template>
  <div class="container">
    <div class="" style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
        <i class="el-icon-s-fold" ></i>
        <el-breadcrumb separator="/" >
          <el-breadcrumb-item >内容管理</el-breadcrumb-item>
          <el-breadcrumb-item class="bread" :to="{ path: '/manage/consumables/consumables-list' }">耗材管理</el-breadcrumb-item>
          <el-breadcrumb-item >耗材出库</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="cons-add">
      <dv-border-box-12 style="padding: 5px 0px;">
        <div style="padding:1px 6px 0px 6px">
          <div class="header-common">
            <div class="header-common-left">
              <div class="title">耗材出库</div>
            </div>
          </div>
          <el-form
            :model="form"
            label-width="100px"
            class="add-form"
            :rules="rules"
            ref="form">
            <el-form-item label="耗材UDI" prop="cons_udi" class="sdsdsd">
              <el-input id="cons_udi" v-model="form.cons_udi" placeholder="耗材UDI" style="width: 50%;float: left;" readonly>
              </el-input>
              <el-button @click="showCons" size='mini' style="margin-left: 10px;">选择耗材</el-button>
              <!-- <el-button @click="showCons" size='mini' style="margin-left: 10px;">选择耗材</el-button> -->
              <!-- <el-select
                v-model="form.cons_udi"
                placeholder="选择耗材"
                style="width: 50%"
                :teleported="false"
                @change="consNameChange($event)"
                >
                <el-option
                  v-for="item in consInventoryData"
                  :key="item.udi"
                  :label="item.name"
                  :value="item.udi"
                  >
                  <span style="float: left">{{ item.udi }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px;margin-left: 20px;">{{item.entranceDate}}入库</span>
                  <span style="float: right; color: #8492a6; font-size: 13px;margin-left: 30px;">{{item.type}}</span>
                </el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item label="出库日期" prop="shipDate" class="time" style="margin-top: 30px;">
                 <el-date-picker
                      id="shipDate"
                      v-model="form.shipDate"
                      type="date"
                      placeholder="选择出库日期"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      :teleported="false"
                      >
                  </el-date-picker>
            </el-form-item>
            <el-form-item label="使用单位" prop="hospital_name" class="sdsdsd">
              <el-input id="hospital_name" v-model="form.hospital_name" placeholder="手动输入或点击使用单位列表选择" style="width: 50%;float: left;">
              </el-input>
              <el-button @click="showHospitals" size='mini' style="margin-left: 10px;">选择使用单位</el-button>
              <!-- <el-select
                v-model="form.hospital_name"
                placeholder="使用单位列表"
                style="width: 30%;"
                popper-class="selectCls"
                @change="hosNameChange($event)"
                >
                <el-option
                  v-for="item in hospitalData"
                  :key="item.id"
                  :label="item.name"
                  :value="item"
                  >
                  <span style="float: left">{{ item.provinceName }}</span>
                  <span style="float: right">{{ item.name }}</span>
                </el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item>
              <el-button type="primary" class="action-button" @click="submitForm('form')">立即保存</el-button>
              <el-button class="action-button" @click="resetForm('form')">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </dv-border-box-12>
    </div>

    <template>
      <!-- 能出库的耗材列表 -->
      <el-dialog :visible.sync="showMoreCons" title="耗材列表">
        <el-table
          :data="consInventoryData"
          border
          style="width: 100%;"
          :max-height="400"
          @cell-click="chooseConsUDI"
          >
          <el-table-column
            type="index"
            label="序号">
          </el-table-column>
          <el-table-column
            prop="entranceDate"
            label="入库日期">
          </el-table-column>
          <el-table-column
            prop="type"
            label="类型">
          </el-table-column>
          <el-table-column
            prop="udi"
            label="UDI">
          </el-table-column>
        </el-table>
      </el-dialog>

      <!-- 使用单位列表 -->
      <el-dialog :visible.sync="showMoreHospitals" title="使用单位列表">
        <el-table
          :data="hospitalData"
          border
          style="width: 100%;"
          :max-height="400"
          @cell-click="chooseHospitalName"
          >
          <el-table-column
            type="index"
            label="序号">
          </el-table-column>
          <el-table-column
            prop="provinceName"
            label="所在省">
          </el-table-column>
          <el-table-column
            prop="cityName"
            label="地区">
          </el-table-column>
          <el-table-column
            prop="name"
            label="使用单位">
          </el-table-column>
        </el-table>
      </el-dialog>

    </template>

  </div>
</template>

<script>
  import {areaConversionUtil} from '../../../utils/povince_handle.js'

  export default {
    props: {},
    data() {
      return {
        form: {
          cons_udi: '',
          // hospital_id:'',
          hospital_name:'',
          shipDate:'',//出库日期
        },
        rules: {
          cons_udi: [{ required: true, message: '请选择出库耗材', trigger: 'blur' }],
          shipDate: [{ required: true, message: '请选择出库日期', trigger: 'blur' }],
        },
        hospitalData:[],
        consInventoryData:[],
        showMoreHospitals:false,
        showMoreCons:false
      }
    },
    methods: {
      getHospitalList(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/hospital/list';

        this.$http({
          method:'GET',
          url:url,
          headers:headers
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.hospitals){
                this.hospitalData = obj.data.hospitals;
                areaConversionUtil.codeToName(this.hospitalData);
              }
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      getConsUnused(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/consumable/list-unshipped';

        this.$http({
          method:'GET',
          url:url,
          headers:headers
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.consumables){
                // 获取公司库存数据
                this.consInventoryData = obj.data.consumables;
              }
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      hosNameChange(e){
        // this.form.hospital_id = e.id;
        this.form.hospital_name = e.name;
      },
      consNameChange(val){
        this.form.cons_udi = val;
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.editOneConsumables();
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      editOneConsumables(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/consumable/ship';
        const data = {
          "udi":this.form.cons_udi,
          "hospitalName":this.form.hospital_name,
          "shipDate":this.form.shipDate
          }
        this.$http({
          method:'POST',
          url:url,
          headers:headers,
          data:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              this.$message({
                message:'出库成功',
                type:'success'
              });
              this.resetForm('form')
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      showHospitals(){
        this.showMoreHospitals = true;
      },
      chooseHospitalName(row){
        // this.form.hospital_id = row.id;
        this.form.hospital_name = row.name;
        this.showMoreHospitals = false;
      },
      showCons(){
        this.showMoreCons = true
      },
      chooseConsUDI(row){
        this.form.cons_udi = row.udi;
        this.showMoreCons = false
      },
    },
    created() {
      this.form.cons_udi = this.$route.query.udi;
    },
    mounted() {
      this.getHospitalList()
      this.getConsUnused()
    },
  }
</script>


<style lang="scss" scoped>
  .container {
    height: 100%;
    margin-top: $header-height;

    .bread >>>.el-breadcrumb__inner{
      color: #606266;
      font-weight: 400;
    }

    .header-common{
      width: 100%;
      height: 45px;
      border-radius: 12px 12px 0 0 ;
      background: linear-gradient(-90deg, #001940, #1564BE);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      .header-common-left{
        font-size: 20px;
        font-weight: bold;
        color: #FEFEFE;
        margin-left: 21px;
        .title{
          font-size: 20px;
          font-weight: bold;
          color: #FEFEFE;
        }
      }
    }

    // .selectCls{
    //   max-height: 200px;
    // }

    // .selectCls .el-scrollbar{
    //   max-height: 200px;
    // }

    .cons-add{
      width: 100%;
      height: 390px;//390

      .add-form{
        padding: 25px 5px;

        .el-upload-dragger{
          background-color: #1A3F81;
        }

        .el-input__inner{
          float: left;
          background-color: RGBA(17, 58, 113, 0.5);
          border: 2px solid #1D4BB6;
          border-radius: 6px;
          box-shadow: 2px 2px 0 0 rgba(0,0,0,0.2);
          caret-color: rgba(0,255,255,0.8);
          color: #FFFFFF;
          font-size: 15px;
          font-weight: 400;
        }

        //表单验证错误提示偏移
        .el-form-item__error{
          margin-top: -11px;
        }

        .el-descriptions__body{
          // background-color: #00DEFF;
          border: 0px red solid;
        }

        .el-descriptions-item__cell{
          border: 1px #1D4BB6 solid;
        }
          .my-label {
            // background: #E1F3D8;
            background-color: transparent;
            color: rgba(0,255,255,1);
          }

          .my-content {
            // background: #FDE2E2;
          }

          .action-button{
            width: 120px;
            height: 40px;
            background: #FAFAFA;
            border: 1px solid rgba(0,144,255,0.84);
            border-radius: 20px;
            background-color: #20478D;
            font-size: 14px;
            font-weight: 400;
            color: #00DEFF;
          }
      }
    }

    // .sdsd /deep/.el-popper[x-placement^=bottom] {
    //   margin-top: 42px;
    //   }

    // .el-form-item__label{
    //   color: #FFFFFF;
    //   font-size: 18px;
    //   // font-family: Microsoft YaHei;
    //   font-weight: 400;
    // }



  }

</style>



// WEBPACK FOOTER //
// src/view/manage/consumables/consumables-edit.vue